var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2CloudDay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.15 33.12h-1.78a15.32 15.32 0 00-4.68-9 15.56 15.56 0 00-26 9h-1.84a11.5 11.5 0 100 23h34.3a11.5 11.5 0 000-23zm0 19.16h-34.3a7.669 7.669 0 110-15.33h5.41v-1.87a11.69 11.69 0 1123.38 0v1.87h5.41a7.67 7.67 0 110 15.33h.1z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B2_Cloud_day.1bb2aea9.svg";
export { SvgB2CloudDay as ReactComponent };